
import Vue from 'vue';

/**
 * OWC NBA Item - this is a subcomponent for OWC Next Best Activities
 *
 * @vue-prop {Object} data - the content object
 * @vue-prop {Boolean} [darkMode=fase] - Dark Mode flag
 */
export default Vue.extend({
  props: {
    data: {
      type: Object,
      required: true,
    },
    darkMode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isTextOnly: function(): boolean {
      return !this.data.icon;
    },
  },
});
